module.exports = __webpack_public_path__ + "media/images/icons/filled/windows-423d730db120a3dc28491e936c6a3d40.svg";